var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThunderIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 42,
    viewBox: "0 0 45 42",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.654297,
    y: 0.339844,
    width: 44.0424,
    height: 41.2322,
    rx: 11,
    fill: "#FFBA34"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6299 11.8438L14.5074 22.0922C14.1502 22.4936 13.9715 22.6943 13.9688 22.8637C13.9664 23.0111 14.0366 23.1513 14.159 23.2439C14.2998 23.3504 14.5788 23.3504 15.1369 23.3504H22.6057L21.5814 31.0215L30.7039 20.7731C31.0611 20.3717 31.2398 20.171 31.2425 20.0015C31.2449 19.8542 31.1747 19.714 31.0523 19.6214C30.9115 19.5149 30.6325 19.5149 30.0744 19.5149H22.6057L23.6299 11.8438Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThunderIcon);
export default __webpack_public_path__ + "static/media/thunder-icon.64ef437d7c9297a73059022603d9860a.svg";
export { ForwardRef as ReactComponent };